// utils/secureStorage.ts
import sjcl from "sjcl";

const secret = process.env.REACT_APP_SECRET || "Xkh$%Z@RaF@G4fW2t2W";

/**
 * Encrypt and store values in localStorage
 */
export const setEncryptedTokens = (
  pairs: Array<{ key: string; value: string }>,
) => {
  for (const { key, value } of pairs) {
    console.log("set", key, value);

    if (!value) continue;
    const encrypted = sjcl.encrypt(secret, value);
    localStorage.setItem(key, encrypted);
  }
};

/**
 * Decrypt a value from localStorage
 */
export const getDecryptedToken = (key: string): string | undefined => {
  const encrypted = localStorage.getItem(key);
  if (!encrypted) return undefined;

  try {
    return sjcl.decrypt(secret, encrypted);
  } catch (err) {
    console.error("Decryption failed for key:", key, err);
    return undefined;
  }
};
